import React, { useState, useEffect } from 'react';
import '../css/AdminDashboard.css'; 
import { useNavigate } from 'react-router-dom';
import AdminPendingProducts from './AdminPendingProducts'; // 🛒 Import component here (Path apne folder structure ke hisaab se check kar lein)
import { API_BASE } from '../config';

const AdminDashboard = () => {
  const [partners, setPartners] = useState([]);
  const [orders, setOrders] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('partners'); 
  const navigate = useNavigate("");
  
  const [selectedPartnerForView, setSelectedPartnerForView] = useState(null);
  const [isViewingDashboard, setIsViewingDashboard] = useState(false);
  const [stats, setStats] = useState({ pending: 0, activeVendors: 0 });

  // Fetch partners list
  const fetchPartners = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/admin/partners`);
      const result = await res.json();
      if (result.success) setPartners(result.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch live production orders from the database
  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}/api/admin/orders`);
      const result = await res.json();
      if (result.success) setOrders(result.data);
    } catch (err) {
      console.error("Error fetching ledger data:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/admin/stats `);
      const data = await res.json();
      if (data.success) {
        setStats({ 
          pending: data.pendingProductCount,
          activeVendors: data.activeVendors 
        });
      }
    } catch (err) { console.error("Stats error:", err); }
  };

  useEffect(() => {
    fetchPartners();
    fetchOrders(); 
    fetchStats();
  }, []);

  useEffect(() => {
    if (activeTab === 'orders') {
      fetchOrders();
    } else if (activeTab === 'partners') {
      fetchPartners();
    }
  }, [activeTab]);

  const handleStatusChange = async (id, newStatus) => {
    if(!window.confirm(`Are you sure you want to set status to ${newStatus}?`)) return;
    
    try {
      const res = await fetch(`${API_BASE}/api/admin/partners/${id}/status`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: newStatus })
      });
      const result = await res.json();
      if (result.success) {
        alert(`Partner ${newStatus} successfully!`);
        fetchPartners(); 
      }
    } catch (err) {
      alert("Status update failed!");
    }
  };

  const handleSeePartnerDashboard = (partner) => {
    setSelectedPartnerForView(partner);
    setIsViewingDashboard(true);
  };

  const handleExitPartnerView = () => {
    setSelectedPartnerForView(null);
    setIsViewingDashboard(false);
  };

  const totalPartners = partners.length;
  const pendingRequests = partners.filter(p => p.status === 'Pending').length;
  const activeDistributors = partners.filter(p => p.roleType === 'Vendor' && p.status === 'Approved').length;

  return (
    <div className="admin-dashboard-layout">
      {/* --- SIDEBAR --- */}
      <aside className="admin-sidebar">
        <h2>2look <span>B2B Admin</span></h2>
        <nav>
          <button 
            className={activeTab === 'dashboard' && !isViewingDashboard ? 'active' : ''} 
            onClick={() => { setActiveTab('dashboard'); setIsViewingDashboard(false); }}
          >
            📊 Overview
          </button>
          <button 
            className={activeTab === 'partners' && !isViewingDashboard ? 'active' : ''} 
            onClick={() => { setActiveTab('partners'); setIsViewingDashboard(false); }}
          >
            👥 Partner Requests ({stats.pending})
          </button>
          
          <button 
            className={activeTab === 'orders' && !isViewingDashboard ? 'active' : ''} 
            onClick={() => { setActiveTab('orders'); setIsViewingDashboard(false); }}
          >
            📦 Live Orders Ledger ({orders.length})
          </button>

          {/* 🛒 B2B Products Tab */}
          <button 
            className={activeTab === 'products' && !isViewingDashboard ? 'active' : ''} 
            onClick={() => { setActiveTab('products'); setIsViewingDashboard(false); }}
          >
            🛒 B2B Products
          </button>
        </nav>
      </aside>

      {/* --- MAIN CONTENT --- */}
      <main className="admin-main">
        
        {!isViewingDashboard && (
          <div className="admin-stats-grid">
            <div className="stat-card">
              <h4>Total B2B Partners</h4>
              <p>{totalPartners}</p>
            </div>
            <div className="stat-card pending">
              <h4>Pending Approvals</h4>
              <p>{pendingRequests}</p>
            </div>
            <div className="stat-card active-partners">
              <h4>Active Vendors</h4>
              <p>{activeDistributors}</p>
            </div>
          </div>
        )}

        {isViewingDashboard ? (
          <div className="table-container impersonation-view" style={{ padding: '20px', background: '#fff', borderRadius: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #eee', paddingBottom: '15px' }}>
              <div>
                <span className="badge" style={{ backgroundColor: '#ffc107', color: '#000', marginRight: '10px', padding: '5px 10px', borderRadius: '4px', fontWeight: 'bold' }}>ADMIN LIVE INSPECTION MODE</span>
                <h3 style={{ margin: '10px 0 0 0' }}>Viewing Dashboard: <span style={{ color: '#007bff' }}>{selectedPartnerForView?.companyName || "N/A"}</span></h3>
              </div>
              <button 
                onClick={handleExitPartnerView} 
                style={{ padding: '10px 20px', backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
              >
                ← Exit View Mode
              </button>
            </div>

            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', marginTop: '20px' }}>
              <h4 style={{ borderBottom: '1px solid #ddd', paddingBottom: '10px', color: '#333' }}>📋 Detailed Operational Credentials</h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginTop: '15px' }}>
                <p><strong>Representative Name:</strong> {selectedPartnerForView?.contactName || 'N/A'}</p>
                <p><strong>Designation:</strong> {selectedPartnerForView?.designation || 'N/A'}</p>
                <p><strong>System Identification Code:</strong> {selectedPartnerForView?.userCode || 'N/A'}</p>
                <p><strong>Role Base:</strong> {selectedPartnerForView?.roleType} {selectedPartnerForView?.subRoleType !== 'None' ? `(${selectedPartnerForView?.subRoleType})` : ''}</p>
              </div>
            </div>
          </div>
        ) : (
          <>
            {activeTab === 'partners' && (
              <div className="table-container">
                <h3>Partner Registration Verification Pipeline</h3>
                {loading ? <p>Loading Requests...</p> : (
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Company / Name</th>
                        <th>Partner Type</th>
                        <th>Contact & Email</th>
                        <th>Bank Account Details</th>
                        <th>GSTIN / PAN</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {partners.map(partner => (
                        <tr key={partner.id}>
                          <td>
                            <strong>{partner.companyName || "N/A"}</strong><br />
                            <span className="sub-text">By: {partner.contactName}</span>
                          </td>
                          <td>
                            <span className={`badge role-${(partner.roleType || '').replace(/\s+/g, '')}`}>
                              {partner.roleType || 'None'} {partner.subRoleType && partner.subRoleType !== 'None' ? `(${partner.subRoleType})` : ''}
                            </span>
                          </td>
                          <td>
                            {partner.mobileNumber}<br />
                            <span className="sub-text">{partner.emailAddress}</span>
                          </td>
                          <td style={{ fontFamily: 'monospace', fontWeight: '500' }}>
                            {partner.accountNumber || <span style={{ color: '#dc3545', fontSize: '11px' }}>Not Found ⚠️</span>}
                          </td>
                          <td>
                            <span className="sub-text">GST: {partner.gstin || "N/A"}</span><br />
                            <span className="sub-text">PAN: {partner.panNumber}</span>
                          </td>
                          <td><span className={`badge status-${(partner.status || 'pending').toLowerCase()}`}>{partner.status}</span></td>
                          <td>
                            <div className="action-btns" style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                              <button 
                                className="btn-approve" 
                                style={{ backgroundColor: '#007bff', color: '#fff' }} 
                                onClick={() => handleSeePartnerDashboard(partner)}
                              >
                                See Dashboard
                              </button>

                              {partner.status === 'Pending' && (
                                <>
                                  <button className="btn-approve" onClick={() => handleStatusChange(partner.id, 'Approved')}>Approve</button>
                                  <button className="btn-reject" onClick={() => handleStatusChange(partner.id, 'Rejected')}>Reject</button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}

            {activeTab === 'orders' && (
              <div className="table-container">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                  <h3>Live B2B Corporate Orders Log</h3>
                  <button onClick={fetchOrders} style={{ padding: '6px 12px', background: '#343a40', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>🔄 Force Refresh</button>
                </div>
                {loading ? <p>Pulling database live records...</p> : orders.length === 0 ? <p>No current orders logged in ledger database.</p> : (
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Buyer & Corporate Info</th>
                        <th>Product Parameters</th>
                        <th>Settlement Mode</th>
                        <th>Grand Total</th>
                        <th>Voucher Code Used</th>
                        <th>Ledger Timestamp</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orders.map(order => (
                        <tr key={order.id}>
                          <td style={{ fontWeight: 'bold', color: '#495057' }}>#00{order.id}</td>
                          <td>
                            <strong>{order.buyerName}</strong><br />
                            <span className="sub-text">{order.companyName || 'Retail Purchase'}</span><br />
                            <span className="sub-text">{order.phone}</span>
                          </td>
                          <td>
                            <strong>{order.productTitle}</strong><br />
                            <span className="sub-text" style={{ color: '#007bff', fontWeight: '600' }}>Volume: {order.quantity} units</span>
                          </td>
                          <td>
                            <span className={`badge`} style={{ textTransform: 'uppercase', backgroundColor: order.paymentMethod === 'netbanking' ? '#e3f2fd' : '#f5f5f5', color: order.paymentMethod === 'netbanking' ? '#0d47a1' : '#424242' }}>
                              {order.paymentMethod}
                            </span>
                          </td>
                          <td style={{ fontWeight: 'bold', color: '#198754' }}>
                            ₹{order.grandTotal.toLocaleString('en-IN')}.00
                          </td>
                          <td>
                            <span style={{ fontSize: '12px', background: '#e9ecef', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace' }}>
                              {order.membershipUsed || 'None'}
                            </span>
                          </td>
                          <td className="sub-text">
                            {new Date(order.createdAt).toLocaleString('en-IN')}
                          </td>
                          <td>
                            <span className="badge status-pending" style={{ background: '#ffc107', color: '#000' }}>
                              {order.orderStatus || 'Pending'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}

            {/* --- B2B Products Tab Integration --- */}
            {activeTab === 'products' && (
              <AdminPendingProducts onStatsUpdate={fetchStats} />
            )}
          </>
        )}
      </main>
    </div>
  );
};

export default AdminDashboard;